// 時間別入力で「入力する枠」を決める（ADR 0031）。
//
// 時間別入力は、その1時間が終わってから入れることが多い（12:00〜13:00 の分を 13:05 に入れる）。
// 時計の時刻の枠（13:00〜14:00）を開くと、入れたい枠が畳まれて毎回押し直しになる。
// そこで毎正時から graceMinutes 分までは直前に終わった枠、それ以降は今の枠を開く。

// 毎正時から何分まで、直前の枠を「入力する枠」とみなすか（利用者判断・2026-10-18）。
export const DEFAULT_GRACE_MINUTES = 30;

/**
 * @param {{hour: number, minute: number, slots: number[], graceMinutes?: number}} p hour/minute は JST
 * @returns {{hour: number, kind: 'previous'|'current'} | null}
 *   previous = 直前に終わった枠、current = 今の枠。開く枠が無い時刻は null。
 */
export function inputSlot({ hour, minute, slots, graceMinutes = DEFAULT_GRACE_MINUTES }) {
  const has = (h) => Array.isArray(slots) && slots.includes(h);
  if (minute < graceMinutes && has(hour - 1)) return { hour: hour - 1, kind: 'previous' };
  if (has(hour)) return { hour, kind: 'current' };
  return null;
}
